import "../scss/main.scss";

import "./src/RichText";
import DeferImages from "./src/DeferImages";

// React
import initComponents from "./src/components";

if (window.NodeList && !NodeList.prototype.forEach) {
  // @ts-ignore
  NodeList.prototype.forEach = Array.prototype.forEach;
}

(function () {
  // Video Block
  const videoBlock: NodeListOf<HTMLElement> =
    document.querySelectorAll(".video-block");
  if (videoBlock?.length > 0) {
    for (let i = 0; i < videoBlock.length; i++) {
      import(/* webpackChunkName: "videoBlock" */ "./src/VideoBlock").then(
        (e) => {
          e.default(videoBlock[i]);
        }
      );
    }
  }

  // Defer Images
  if (
    document.querySelector("img[data-src]") ||
    document.querySelector("div[data-src]")
  ) {
    new DeferImages();
  }

  // Accordion
  if (document.querySelector(".accordionblock")) {
    const accordions: NodeListOf<HTMLElement> = document.querySelectorAll(
      ".accordionblock .tni-card"
    );
    import(/* webpackChunkName: "accordion" */ "./src/Accordion").then((e) => {
      for (let i = 0; i < accordions.length; i++) {
        e.default(accordions[i]);
      }
    });
  }

  // Menu
  const nav = document.querySelector("nav");
  if (nav) {
    document
      .querySelector(".mobile-menu-button")
      .addEventListener("click", () => {
        nav.classList.toggle("active");
        document.body.classList.toggle("mobile-menu-active");
        document
          .querySelector(".overflow-container")
          .classList.toggle("hidden");
      });
  }

  // Browsealoud dismiss bar
  const browsealoudBar = document.querySelector(".jsBrowsealoudBar");
  if (browsealoudBar) {
    if (sessionStorage.getItem("browsealoud")) {
      browsealoudBar.classList.add("d-none");
    } else {
      browsealoudBar.classList.remove("d-none");
    }
    document
      .querySelector(".jsBrowsealoudClose")
      .addEventListener("click", () => {
        browsealoudBar.classList.add("d-none");
        sessionStorage.setItem("browsealoud", "true");
      });
  }

  const profile = document.querySelectorAll(".profile");
  if (profile) {
    Array.from(profile).forEach((button) => {
      button.firstElementChild.addEventListener("click", function (e) {
        if (this.getAttribute("aria-expanded") === "true") {
          this.setAttribute("aria-expanded", "false");
        } else {
          this.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  const sideNav = document.querySelector(".sidebar-nav-mobile");
  if (sideNav) {
    sideNav.children[0].addEventListener("click", () => {
      sideNav.classList.toggle("active");
    });
  }

  const teasers = document.querySelectorAll(".bottom-contentarea .teaserblock");

  if (teasers?.length > 0) {
    const { filter } = Array.prototype;
    const filtered = filter.call(
      teasers,
      (node) => !node.closest(".thehubgenericlistingblock")
    );
    if (filtered?.length > 0) {
      import(/* webpackChunkName: "wrapDivs" */ "./src/WrapDivs").then((e) => {
        e.default(filtered, ["related-content", "row"]);
        e.default(document.querySelectorAll(".related-content"), [
          "related-content-wrapper"
        ]);
      });
    }
  }

  if (document.querySelector(".TheHubLearningResourcesListingPage")) {
    import(
      /* webpackChunkName: "learningResources" */ "./src/LearningResources"
    ).then((e) => {
      e.default();
    });
  }

  const stepForms: NodeListOf<HTMLFormElement> = document.querySelectorAll(
    "form[enctype='multipart/form-data']"
  );
  if (stepForms?.length > 0) {
    stepForms.forEach((f) => {
      import(
        /* webpackChunkName: "multiStepForm" */ "./src/MultiStepForm"
      ).then((e) => {
        e.default(f);
      });
    });
  }

  initComponents();
})();
